export default (images = [], provisionalBase64Image) => {
  if (!images || !images.length) {
    return [];
  }

  const [firstImage, ...rest] = images;
  return [{ ...firstImage, provisionalBase64Image }, ...rest];
};
